<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container mt-5">
        <div class="row">
          <div class="col-12 card">
            <div class="px-5" v-if="btnList">
              <a
                href="javascript:;"
                class="badge datebtn"
                v-for="btn in btnList"
                :key="btn"
                :class="{ 'badge-dark': btn === nowDate }"
                @click.prevent="changeDataHandler(btn)"
                >{{ btn }}</a
              >
            </div>
            <div class="card-title mt-3 text-right">
              <span class="h6">* 多款件數已扣原訂單</span>
            </div>
            <div class="card-body">
              <div class="bootstrap-data-table-panel">
                <div class="table-responsive">
                  <table id="multiOrdersTable" class="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>製稿人員</th>
                        <th>部門</th>
                        <th>總件數</th>
                        <th class="text-center">單模多款件數</th>
                      </tr>
                    </thead>
                    <tbody v-if="listAry">
                      <tr v-for="(item, index) in listAry" :key="item.mrid">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.EmployeeName }}</td>
                        <td>{{ item.zip }}</td>
                        <td style="width:25%">{{ item.orderCount }}</td>
                        <td class="text-center" style="width:25%">
                          {{ item.multiOrdersCount }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot v-if="listAry">
                      <tr>
                        <th colspan="3"></th>
                        <th>總件數</th>
                        <th class="text-center">單模多款件數</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/js/lib/data-table/jquery.dataTables.min.js';
import '../../assets/js/lib/data-table/dataTables.buttons.min.js';
import '../../assets/js/lib/data-table/buttons.flash.min.js';
import '../../assets/js/lib/data-table/jszip.min.js';
import 'pdfmake';
import '../../assets/js/lib/data-table/vfs_fonts.js';
import '../../assets/js/lib/data-table/buttons.html5.min.js';
import '../../assets/js/lib/data-table/buttons.print.min.js';
export default {
  name: 'multiorder',
  props: {
    time: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mainDep: '',
      mainData: [],
      nowDate: '',
      dateList: []
    };
  },
  mounted() {
    this.mainDep = this.$route.params.dep;
    let date = new Date();
    date.setDate(0);
    date = `${date.getFullYear()}${date.getMonth() + 1}`;
    this.getDataHandler(this.mainDep, date);
    this.getDateList();
  },
  computed: {
    ordersData() {
      return this.mainData;
    },
    btnList() {
      return this.dateList.length > 0 ? this.dateList : false;
    },
    listAry() {
      return this.mainData.length > 0
        ? this.mainData.map(el => {
            let code = el.DepartmentID.split('-')[1];
            let zip =
              code === '01'
                ? '台中'
                : code === '35'
                ? '新莊'
                : code === '71'
                ? '高雄'
                : code;
            zip += '名片部';
            el.zip = zip;
            return el;
          })
        : false;
    },
    sum() {
      return this.mainData.length > 0
        ? this.mainData.reduce(
            (prev, curr) => {
              prev.orders += curr.orderCount * 1;
              prev.multi += curr.multiOrdersCount * 1;
              return prev;
            },
            { orders: 0, multi: 0 }
          )
        : false;
    }
  },
  methods: {
    getDataHandler(dep, date) {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: {
          function: 'getMultiOrdersData',
          dep,
          date
        }
      }).done(res => {
        this.nowDate = date;
        this.mainData = JSON.parse(res);
        this.$nextTick(function() {
          this.renderMultiOrdersTable();
        });
      });
    },
    renderMultiOrdersTable() {
      let dataTableObj = {
        domID: '#multiOrdersTable',
        Colums: ['_all'],
        Orders: ['1', 'desc'],
        destroyTrigger: ['.datebtn@click']
      };
      UseDataTablePlugin(dataTableObj);
    },
    getDateList() {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: { function: 'getDateList', dep: this.mainDep }
      }).done(res => {
        this.dateList = JSON.parse(res);
      });
    },
    changeDataHandler(date) {
      let dep = this.mainDep;
      this.getDataHandler(dep, date);
    }
  }
};

function UseDataTablePlugin(Obj) {
  let table = $(`${Obj.domID}`).DataTable({
    dom: 'Bfrtip',
    lengthMenu: [[25, 50, -1], [25, 50, 'All']],
    columnDefs: [
      {
        targets: Obj.Colums,
        className: 'dt-center',
        render(data) {
          let color = 'black';
          return '<span style="color:' + color + '">' + data + '</span>';
        }
      }
    ],
    buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
    // order: Obj.Orders,
    destroy: true,
    language: {
      emptyTable: '尚無資料',
      paginate: {
        previous: '上一頁',
        next: '下一頁'
      }
    },
    autoWidth: false,
    bInfo: false,
    footerCallback: function(row, data, start, end, display) {
      var api = this.api(),
        data;
      var intVal = function(i) {
        return typeof i === 'string'
          ? i.replace(/[\$,]/g, '') * 1
          : typeof i === 'number'
          ? i
          : 0;
      };
      var total = api
        .column(3)
        .data()
        .reduce(function(a, b) {
          return intVal(a) + intVal(b);
        }, 0);

      var multi = api
        .column(4)
        .data()
        .reduce(function(a, b) {
          return intVal(a) + intVal(b);
        }, 0);

      $(api.column(0).footer()).html();
      $(api.column(3).footer()).html(total);
      $(api.column(4).footer()).html(multi);
    }
  });
  Obj.destroyTrigger.forEach(el => {
    let dom = el.split('@')[0];
    let action = el.split('@')[1];
    $(`${dom}`).one(`${action}`, () => table.destroy());
  });
}
</script>

<style>
#multiOrdersTable {
  font-size: 1.1em !important;
}
</style>